import Vue from "vue";
import VueRouter from "vue-router";
const Home = () => import("@/views/Home");
const Business = () => import("@/views/business-page/index");
const Customer = () => import("@/views/business-page/customer");
const Activity = () => import("@/views/activity/index");
const Reward = () => import("@/views/activity/reward");
const Gift = () => import("@/views/gift/index");
const Lottery = () => import("@/views/gift/lottery");
const LotteryList = () => import("@/views/gift/lottery-list");
const ClueCollect = () => import("@/views/clue-collect/index");
const Raffle = () => import("@/views/clue-collect/raffle");
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/business",
    name: "business",
    component: Business,
    meta: { title: "三一云联金服1号祝您圆挖机梦" },
  },
  {
    path: "/customer",
    name: "customer",
    component: Customer,
    meta: { title: "三一云联金服1号祝您圆挖机梦" },
  },
  {
    path: "/activity",
    name: "activity",
    component: Activity,
    meta: { title: "疯狂四月 | 上传车源赢奖励" },
  },
  {
    path: "/reward",
    name: "reward",
    component: Reward,
    meta: { title: "疯狂四月 | 上传车源赢奖励" },
  },
  {
    path: "/gift",
    name: "gift",
    component: Gift,
    meta: { title: "疯狂四月 | 上传车源赢奖励" },
  },
  {
    path: "/lottery",
    name: "lottery",
    component: Lottery,
    meta: { title: "疯狂四月 | 上传车源赢奖励" },
  },
  {
    path: "/lotteryList",
    name: "lotteryList",
    component: LotteryList,
    meta: { title: "疯狂四月 | 上传车源赢奖励" },
  },
  {
    path: "/clueCollect",
    name: "clueCollect",
    component: ClueCollect,
    meta: { title: "买二手设备上云联二手机" },
  },
  {
    path: "/raffle",
    name: "raffle",
    component: Raffle,
    meta: { title: "买二手设备上云联二手机" },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
